import PrimaryBtn from "@/components/Buttons/PrimaryButton";
import getCategory from "@/functions/getCategory";
import HeaderBackground from "@/assets/job-ad/header-background.svg";
import ExternalLink from "@/assets/job-ad/external-link.svg";
import Link from "next/link";
import useLocale from "@/hooks/useLocale";
import localizePath from "@/functions/localizePath";

export default function JobPageHeader({ job }) {
  const locale = useLocale();
  const category = getCategory(job);

  return (
    <div className="relative w-full bg-green pl-[30px] md:pl-[72px] pr-[30px] pt-14 pb-6 md:min-h-[438px] text-[#1B0D34] overflow-hidden">
      <div className="absolute -right-[100px] -top-[180px] z-0">
        <HeaderBackground />
      </div>
      <div className="relative z-10 flex flex-col justify-between gap-12">
        <div className="flex flex-col gap-6 font-normal">
          <div className="text-2xl/[40px] md:text-[40px]/[60px] lg:text-[50px] max-w-[650px]">
            <span>{job?.title}</span>
          </div>
          <div className="text-2xl md:text-3xl">
            <span>{job?.salary_package}</span>
          </div>
          <div className="flex gap-2">
            {category?.map((type) => (
              <div
                key={type.id}
                className="bg-midnight-blue text-white text-base min-h-[44px] py-3 px-5 flex justify-center items-center text-center"
              >
                <span>{type.name}</span>
              </div>
            ))}
          </div>
        </div>
        <div className="text-base md:text-xl font-medium flex flex-col sm:flex-row justify-between">
          <Link
            className="text-sm sm:text-base md:text-lg lg:text-xl"
            color="purple"
            href={localizePath("/jobs", locale)}
          >
            <span className="">Back to all jobs</span>
          </Link>
          <div className="flex justify-center items-center gap-6">
            <a
              href={`mailto:${job?.external_application_email}`}
              target="_blank"
              className="text-sm sm:text-base md:text-lg lg:text-xl group/link"
            >
              <div className="flex items-center gap-3">
                Email to a colleague
                <ExternalLink />
              </div>
            </a>
            <div>
              <PrimaryBtn
                href="#job-form"
                bgColor="green"
                color="purple"
                className="py-3 px-6"
              >
                Apply
              </PrimaryBtn>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
